export default __webpack_public_path__ + "static/media/routines.42382265.svg";